module.exports = __webpack_public_path__ + "img/landing34.3e8831ef.jpg";